import { storage } from '@/lib/storage';
import { Supplier } from '@/types';
import { nanoid } from 'nanoid';

const SUPPLIERS_KEY = 'suppliers';

export const supplierService = {
  getAll: (): Supplier[] => {
    return storage.get<Supplier[]>(SUPPLIERS_KEY) || [];
  },

  getById: (id: string): Supplier | null => {
    const suppliers = supplierService.getAll();
    return suppliers.find(s => s.id === id) || null;
  },

  getActive: (): Supplier[] => {
    return supplierService.getAll().filter(s => s.is_active);
  },

  create: (data: Omit<Supplier, 'id' | 'created_at' | 'updated_at'>): Supplier => {
    const suppliers = supplierService.getAll();
    const newSupplier: Supplier = {
      ...data,
      id: nanoid(),
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };
    suppliers.push(newSupplier);
    storage.set(SUPPLIERS_KEY, suppliers);
    return newSupplier;
  },

  update: (id: string, data: Partial<Supplier>): Supplier | null => {
    const suppliers = supplierService.getAll();
    const index = suppliers.findIndex(s => s.id === id);
    if (index === -1) return null;
    
    suppliers[index] = {
      ...suppliers[index],
      ...data,
      id: suppliers[index].id,
      created_at: suppliers[index].created_at,
      updated_at: new Date().toISOString(),
    };
    storage.set(SUPPLIERS_KEY, suppliers);
    return suppliers[index];
  },

  delete: (id: string): boolean => {
    const suppliers = supplierService.getAll();
    const filtered = suppliers.filter(s => s.id !== id);
    if (filtered.length === suppliers.length) return false;
    storage.set(SUPPLIERS_KEY, filtered);
    return true;
  },
};
